import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { SessionExpiredComponent } from './components/session-expired/session-expired.component';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AgmCoreModule } from '@agm/core';
import { PaginationComponent } from './components/pagination/pagination.component';
import { AgmDirectionModule } from 'agm-direction';
import { FullCalendarModule } from '@fullcalendar/angular';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MismatchPipe } from './pipes/mismatch.pipe';
import { CellStylePipe } from './pipes/cellStyle.pipe';


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    NgSelectModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBJD_8dhD6WCivsQzLAOg1NhrJVMZTrW-w',
      libraries: ['places']
    }),
    AgmDirectionModule,
    FullCalendarModule,
    NgbTooltipModule
  ],
  exports: [CommonModule,
    AgmDirectionModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    FullCalendarModule,
    RouterModule, NgbTooltipModule, NavbarComponent, FooterComponent, NotFoundComponent, SessionExpiredComponent, AccessDeniedComponent, PaginationComponent, AgmCoreModule, MismatchPipe, CellStylePipe],
  declarations: [NavbarComponent, FooterComponent, NotFoundComponent, SessionExpiredComponent, AccessDeniedComponent, PaginationComponent, MismatchPipe, CellStylePipe]
})
export class SharedModule {

  /*** This static forRoot block (provides and configures services) is
* used in case of when we want use some services in one or more components.
*/
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: SharedModule,
      providers: []
    };
  }
}
